export default {
  title: "",
  subtitle: "",
  path: "document_upload",
  paragraph: "When sending the documents required, you can use the following endpoint. Using it, you can send, list and show details of the documents related to that specific subject_id. There are two possible ways to send us the documents: by URL or by file (Base64 encoded, no more than 15MB per file).",
  image: {
    path: "/static/diagrams/customerApproval.png",
    description: "Steps for customer registration and approval"
  },
  request: {
    method: "POST",
    endpoint: "/subject/:id/documents",
    payloads: [
      {
        title: "Payload using a file",
        content: {
          "document": {
            "labels": ["address-proof"],
            "file_data": "Base64-encoded-string",
            "file_type": "application/pdf",
            "file_name": "document.pdf",
          }
        }
      },
      {
        title: "Payload using a URL",
        content: {
          "document": {
            "labels": ["rg-number", "cpf-number", "rg-photo"],
            "file_url": "https://www.rearden.co.us/files/47358347534875.jpeg",
            "file_type": "image/jpeg",
          }
        }
      }
    ],
    responses: {
      "data": { 
        "labels": [ 
          "rg-number", 
          "cpf-number", 
          "rg-photo" 
        ], 
        "id": "b258d5e5-8959-4aa5-b146-05c3b3366ba8", 
        "file_url": "https://www.rearden.co.us/files/47358347534875.jpeg",
        "file_type": "image/jpeg",
      } 
    },
  },
  pathPayload: [
    {
      name: "id",
      type: "string",
      required: true,
      description: "Customer UUID"
    }
  ],
  parameterPayload: [
      {
      name: "document",
      type: "array",
      required: true,
      description: "An array of documents related to the Customer",
      is_parent: true,
    },
    {
      name: "document.labels",
      type: "array",
      required: true,
      description: "Labels that will help describe the document.",
      requiredFor: "Payload using a file_data and URL"
    },
    {
      name: "document.file_type",
      type: "string",
      required: true,
      description: "Document file MIME type. Must match the document type.",
      requiredFor: "Payload using a file_data and URL"
    },
    {
      name: "document.file_data",
      type: "string",
      required: false,
      description: "Document file encoded in Base64.",
      requiredFor: "Payload using a file_data"
    },
    {
      name: "document.file_name",
      type: "string",
      required: false,
      description: "Name which the file will be stored.",
      requiredFor: "When using sending file_data"
    },
    {
      name: "document.file_url",
      type: "string",
      required: false,
      description: "URL to your image",
      requiredFor: "Payload using a URL"
    }
  ],
  troubleshooting: {
    title: 'Common mistakes',
    messages: [
      {
        code: {
          "file_data": [
            "upload error"
          ]
        },
        solution: 'Ensure the posted file data is encoded in Base64.'
      },
      {
        code: 'Bad Request(400)',
        solution: 'Make sure all required fields are present in your request.'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Documents/DocumentUpload.js